import './Footer.css';
import '../../styles/styles.css';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchTerms } from '../../features/regulation/RegulationAcceptanceSlice';

function Footer() {
const termOfUse = useSelector((state)=>state.terms.termOfUseURL);
const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(fetchTerms());
  },[dispatch])

  return (
  <div className="footer">
    <div className="PRO-text">
    © 2022 PRO  
    </div>
    <div className="terms-text">
      <a href={termOfUse} target="_blank" rel="noopener noreferrer" style={{textTransform:'none', color: '#000000', fontWeight:'normal', lineHeight:'20px'}}> 
        Regulamin
      </a>
    </div>
</div>
  );
}

export default Footer;
